export const translations = {
  app: {
    default: 'Standaard',
    company: 'Afosto',
    title: 'Dashboard',
    searchBar: {
      search: {
        label: 'Zoeken',
        placeholder: 'Zoeken',
      },
    },
    switchedTenant: {
      title: 'Organisatie gewisseld',
      message:
        'Je bent van organisatie gewisseld in een ander venster. Klik hieronder op de "Ok" knop, om in het huidige venster te wisselen naar deze organisatie.',
      actions: {
        ok: 'Ok',
      },
    },
    dock: {
      iam: 'Dashboard',
      spl: 'Spooler',
      cnt: 'Files',
      mes: 'Berichten',
      dashboard: 'Afosto',
      notifications: 'Notificaties',
      fulfilment: 'Fulfilment',
      picker: 'Picker',
      spooler: 'Spooler',
      products: 'Producten',
      user: 'Gebruiker',
      wms: 'WMS',
      rel: 'Contacten',
      order: 'Orders',
      messaging: 'Berichten',
      userMenu: {
        signOut: 'Uitloggen',
        selectTenant: 'Selecteer een organisatie',
        searchTenants: {
          placeholder: 'Zoeken naar organisaties',
        },
        addNewTenant: {
          title: 'Nieuwe organisatie toevoegen',
          subtitle: 'Vraag toegang aan voor een nieuwe organisatie',
        },
        emptyTenants: 'Geen organisaties gevonden',
        subtenantForm: {
          description:
            'Voer het e-mailadres in van de organisatie waar je toegang toe wilt verkrijgen.',
          fields: {
            signee: 'E-mailadres',
          },
          actions: {
            cancel: 'Annuleren',
            sent: 'Verstuur verzoek',
          },
        },
        switchTenant: 'Switch organisatie',
      },
      notificationsMenu: {
        none: 'Geen notificaties',
        all: 'Alle notificaties',
      },
    },
    navigation: {
      main: {
        overview: 'Overzicht',
        auditLog: 'Activiteiten log',
        users: 'Gebruikers',
        externalAccess: 'Externe toegang',
        rbac: 'Rollen',
        profile: 'Mijn profiel',
        oauthClients: 'Koppelingen',
        channels: 'Verkoopkanalen',
        settings: 'Instellingen',
        appStore: 'App store',
        integrations: 'Integraties',
      },
    },
    users: {
      preview: {
        viewDetails: 'Bekijk details',
        openStatistics: 'Open statistieken',
        sendMessage: 'Stuur een bericht',
        copyLink: 'Link kopiëren',
        delete: 'Verwijderen',
      },
    },
    role: {
      preview: {
        delete: 'Verwijderen',
      },
    },
    unauthorizedMessage: 'Je hebt geen toestemming om deze informatie in te zien.',
  },
  confirmCancelFormDialog: {
    title: 'Venster verlaten',
    description:
      'Weet je zeker dat je het venster wilt verlaten? Wijzigingen zullen niet worden opgeslagen.',
    buttons: {
      cancel: 'Annuleren',
      leaveWindow: 'Venster verlaten',
    },
  },
  authorizationTypes: {
    invite: 'Uitgenodigd',
    request: 'Verzoek ingediend',
  },
  authorizationStates: {
    pending: 'In afwachting',
    approved: 'Geaccepteerd',
    declined: 'Geweigerd',
    denied: 'Geweigerd',
    revoked: 'Ingetrokken',
    expired: 'Verlopen',
  },
  dateOptions: {
    today: 'Vandaag',
    relativeNow: 'Relatief vanaf nu',
    relative: 'Relatief',
    date: 'Datum',
  },
  betweenOptions: {
    from: 'Van',
    to: 'Tot en met',
  },
  roles: {
    admin: 'Administrator',
    developer: 'Developer',
    user: 'Medewerker',
  },
  pages: {
    appStore: {
      title: 'App store',
    },
    integrations: {
      title: 'Integraties',
      integrationForm: {
        fields: {
          spid: {
            helperText: "Selecteer alleen als de verzendmethode 'pick_up' van 'tenant' is",
          },
        },
      },
    },
    channels: {
      title: 'Verkoopkanalen',
      create: {
        button: 'Verkoopkanaal aanmaken',
      },
      confirmDeleteChannel: {
        title: 'Verkoopkanaal verwijderen',
        description: 'Weet je zeker dat je dit verkoopkanaal wilt verwijderen?',
      },
      feedback: {
        channelDeleted: 'Verkoopkanaal is verwijderd',
        channelNotDeleted: 'Verkoopkanaal kon niet worden verwijderd',
      },
    },
    viewChannel: {
      breadcrumbs: {
        channels: 'Verkoopkanalen',
      },
      unknownChannel: {
        title: 'Onbekend verkoopkanaal',
        message: 'Dit verkoopkanaal bestaat niet',
      },
    },
    viewIntegration: {
      breadcrumbs: {
        integrations: 'Integraties',
      },
      subNavigation: {
        details: 'Details',
        logs: 'Activiteiten',
      },
      integrationInformation: {
        title: 'Informatie',
      },
      integrationApp: {
        title: 'App',
      },
      integrationConfiguration: {
        title: 'Instellingen',
      },
      integrationParameters: {
        title: 'Integratie gegevens',
      },
      unknownIntegration: {
        title: 'Onbekende integratie',
        message: 'Deze integratie bestaat niet',
      },
    },
    overview: {
      title: 'Dashboard',
      subTitle: 'Welkom, {fullName}',
      sections: {
        activity: {
          title: 'Activiteiten bekijken',
          description: "Bekijk de activiteiten van jou en je collega's.",
        },
        editProfile: {
          title: 'Profiel bewerken',
          description: 'Bewerk je profiel gegevens.',
        },
      },
    },
    auditLog: {
      title: 'Activiteiten log',
      preview: {
        title: 'Log details',
      },
      methods: {
        authorize: 'Autorisatie',
        login: 'Inloggen',
        issueRefreshToken: 'Sessie verlengd',
        refresh: 'Sessie vernieuwd',
      },
      resources: {
        iam: 'Dashboard app',
        spl: 'Spooler app',
        pkr: 'Picker app',
        mes: 'E-mail app',
        cnt: 'Files app',
        qcq: 'Quicq app',
      },
    },
    externalAccess: {
      title: 'Externe toegang',
      subNavigation: {
        approved: 'Toegang',
        requested: 'Aanvragen',
        invited: 'Uitnodigingen',
        myInvites: 'Mijn uitnodigingen',
        myRequests: 'Mijn aanvragen',
      },
      invite: {
        button: 'Uitnodigen',
        title: 'Gebruiker uitnodigen',
      },
      request: {
        button: 'Nieuwe aanvraag',
        title: 'Toegang aanvragen',
      },
      feedback: {
        userNotFound: 'Gebruiker kan niet worden gevonden',
        inviteApproved: 'Uitnodiging geaccepteerd',
        inviteNotApproved: 'Uitnodiging kan niet worden geaccepteerd',
        inviteDeclined: 'Uitnodiging geweigerd',
        inviteNotDeclined: 'Uitnodiging kan niet worden geweigerd',
        inviteRevoked: 'Uitnodiging ingetrokken',
        inviteNotRevoked: 'Uitnodiging kan niet worden ingetrokken',
        inviteSent: 'Uitnodiging is verstuurd',
        inviteNotSent: 'Uitnodiging kan niet worden verstuurd',
        accessRequested: 'Toegang is aangevraagd',
        accessNotRequested: 'Toegang kan niet worden aangevraagd',
        accessAlreadyRequested: 'Toegang al aangevraagd',
        requestApproved: 'Aanvraag is geaccepteerd',
        requestNotApproved: 'Aanvraag kan niet worden geaccepteerd',
        requestDeclined: 'Aanvraag is afgewezen',
        requestNotDeclined: 'Aanvraag kan niet worden afgewezen',
        requestRevoked: 'Externe toegang ingetrokken',
        requestNotRevoked: 'Externe toegang kan niet worden ingetrokken',
      },
    },
    oauthClients: {
      title: 'Koppelingen',
      create: {
        button: 'Toevoegen',
        title: 'Nieuwe koppeling',
      },
      edit: {
        title: 'Koppeling wijzigen',
      },
      confirmDeleteClient: {
        title: 'Koppeling verwijderen',
        description: 'Weet je zeker dat je deze koppeling wilt verwijderen?',
        buttons: {
          cancel: 'Annuleren',
          delete: 'Vewijderen',
        },
      },
      feedback: {
        oauthClientUpdated: 'Koppeling is bijgewerkt',
        oauthClientNotUpdated: 'Koppeling kan niet worden bijgewerkt',
      },
    },
    contract: {
      title: 'Contract',
      subNavigation: {
        apps: 'Applicaties',
        billing: 'Facturatie',
        developerSettings: 'Ontwikkelaarsinstellingen',
      },
      secondaryActions: {
        requestPurge: 'Contract opschonen',
      },
      apps: {
        subscribe: 'Toevoegen',
        unsubscribe: 'Opzeggen',
        active: 'Actief',
        feedback: {
          subscriptionAdded: 'Applicatie toegevoegd',
          subscriptionNotAdded: 'Applicatie kan niet worden toegevoegd',
        },
        iam: {
          title: 'Account',
          description: 'Beheer je gebruikers, activiteiten en accountgegevens',
        },
        cat: {
          title: 'Producten',
          description: 'Beheer je producten en prijsgroepen',
        },
        spl: {
          title: 'Spooler',
          description: 'Automatiseer je printverkeer naar een lokale printer',
        },
        cnt: {
          title: 'Bestanden',
          description: 'Beheer je bestanden',
        },
        qcq: {
          title: 'Quicq',
          description: 'Beheer je proxy instellingen',
        },
        mes: {
          title: 'E-mails',
          description: 'Beheer je e-mailverkeer vanuit meerdere inboxen',
        },
        lcs: {
          title: 'Fulfilment',
          description: 'Beheer je verzendingen',
        },
        pkr: {
          title: 'Picker',
          description: 'Orders inpakken op jouw manier',
        },
        odr: {
          title: 'Orders',
          description: 'Beheer je orders, facturen en transacties',
        },
        wms: {
          title: 'Warehouse Management System',
          description: 'Beheer je magazijnen, locaties en voorraad',
        },
        rel: {
          title: 'Contacten',
          description: 'Beheer je contacten en organisaties',
        },
      },
      developerSettings: {
        title: 'Gegevens',
      },
      sections: {
        paymentMethods: {
          title: 'Betaalmethodes',
          empty: 'U heeft nog geen automatische betaalmethode geconfigureerd.',
          create: {
            title: 'Betaalmethode toevoegen',
          },
          delete: {
            disabledTooltip: 'Het is verplicht één betaalmethode te hebben',
          },
        },
        billingAddress: {
          title: 'Factuuradres',
          edit: {
            title: 'Factuuradres wijzigen',
          },
          feedback: {
            billingAddressSaved: 'Factuuradres opgeslagen',
            billingAddressNotSaved: 'Factuuradres kan niet worden opgeslagen',
          },
        },
        companyInformation: {
          title: 'Bedrijfsgegevens',
          edit: {
            title: 'Bedrijfsgegeven wijzigen',
          },
          feedback: {
            companyInformationSaved: 'Bedrijfsgegevens opgeslagen',
            companyInformationNotSaved: 'Bedrijfsgegevens kunnen niet worden opgeslagen',
          },
        },
        upcomingInvoices: {
          title: 'Aankomende facturen',
          row: {
            trialDiscount: 'Proefperiode',
          },
        },
        invoices: {
          title: 'Facturen',
        },
      },
      paymentMethods: {
        mandateMessage:
          'Door het opgeven van uw IBAN en het voldoen van deze betaling, geeft u toestemming aan Afosto SaaS b.v. en Stripe, onze betaal service provider, een opdracht te sturen aan uw bank om uw rekening te debiteren en aan uw bank uw rekening te debiteren conform de opdracht.',
        options: {
          iDeal: {
            title: 'Automatische incasso',
            description: 'Bevestigd d.m.v. iDEAL',
            steps: {
              info: {
                title: 'Automatische incasso',
                description:
                  'Om gebruik te kunnen maken van deze methode willen we zeker weten dat jij beschikt over het rekeningnummer dat je wilt gebruiken. Om dit te valideren vragen we je eenmalig € 0.01 over te maken via iDEAL.',
              },
              bankSelect: {
                title: 'Rekeningnummer bevestigen (iDEAL)',
              },
            },
          },
        },
      },
      requestPurgeDialog: {
        title: 'Opschoon verzoek',
        successTitle: 'Opschoon verzoek ingediend',
        description:
          'Een opschoon verzoek verwijdert alle onderstaande data permanent. Deze data kan dus niet worden terug gehaald. De hoofdgebruiker van dit contract ontvangt een email met een link om het dit verzoek te accepteren.',
        successDescription:
          'De link om het contract op te schonen is verstuurd naar de hoofdgebruiker van dit contract op {signee}. Neem met hem/haar contact op om het opschonen te voltooien.',
        dataToPurge: 'Data om op te schonen',
      },
    },
    users: {
      title: 'Gebruikers',
      create: {
        title: 'Nieuwe gebruiker',
        button: 'Toevoegen',
      },
      edit: {
        title: 'Gebruiker wijzigen',
      },
      confirmDeleteUser: {
        title: 'Gebruiker verwijderen',
        description: 'Weet je zeker dat je deze gebruiker wil verwijderen?',
      },
      subNavigation: {
        overview: 'Overzicht',
        invites: 'Uitnodigingen',
      },
      feedback: {
        userCreated: 'Gebruiker toegevoegd',
        userNotCreated: 'Gebruiker toevoegen mislukt',
        userUpdated: 'Gebruiker is bijgewerkt',
        userNotUpdated: 'Gebruiker kan niet worden bijgewerkt',
        userDeleted: 'Gebruiker is verwijderd',
        userNotDeleted: 'Gebruiker kan niet worden verwijderd',
        userInviteSent: 'Uitnodiging is opnieuw verstuurd',
        userInviteNotSent: 'Uitnodiging kan niet worden verzonden',
        userInviteCancelled: 'Uitnodiging ingetrokken',
        userInviteNotCancelled: 'Uitnodiging kan niet worden ingetrokken',
      },
      confirmCancelInvite: {
        title: 'Uitnodiging intrekken',
        description: 'Weet je zeker dat je deze uitnodiging wil intrekken?',
        actions: {
          revoke: 'Intrekken',
          cancel: 'Annuleren',
        },
      },
    },
    profile: {
      title: 'Mijn profiel',
      subNavigation: {
        information: 'Gegevens',
        security: 'Beveiliging',
      },
      sections: {
        twofa: {
          title: 'Authenticatie in twee stappen',
          description:
            'Stel authenticatie in twee stappen in om een extra beveiligingslaag toe te voegen aan je account.',
          actions: {
            delete: {
              dialog: {
                title: 'Authenticatie in twee stappen uitschakelen',
                text: 'Weet je zeker dat je authenticatie in twee stappen wil uitschakelen?',
              },
            },
          },
          authenticatorApp: {
            title: 'Authenticator app',
            description:
              'Met de Google Authenticator app schakel je gemakkelijk authenticatie in twee stappen in, zodat je account nog beter beveiligd is.',
            activeSince: 'Actief sinds {date}',
            backups: {
              title: 'Backup methodes',
            },
          },
          backupMethods: {
            email: 'E-mail',
            sms: 'SMS',
          },
        },
        password: {
          title: 'Wachtwoord',
          description: 'Je kunt je wachtwoord wijzigen door een wachtwoord reset aan te vragen.',
          feedback: {
            resetPasswordEmailSent:
              'Er is een e-mail verzonden naar jouw e-mailadres. Open de link om een ander wachtwoord op te geven.',
            resetPasswordEmailAlreadySent:
              'Er is al een e-mail verstuurd om je wachtwoord te wijzigen. Controleer je inbox of spam map of probeer het later nog een keer.',
            unknownError: 'Er is iets mis gegaan, probeer het later opnieuw.',
          },
        },
      },
      form: {
        steps: {
          backup: {
            title: 'Backup methodes',
            description: 'Kies één of beide backup mogelijkheden en vul de vereiste informatie in.',
            errors: {
              noChannelSelected: 'Kies minstens één backup methode',
            },
          },
          connect: {
            title: 'Verbind Authenticator app',
            description:
              'Download de Authenticator app uit de Play Store voor Android of uit de App Store voor IOS. Open de app en tik op het plus icoontje. Kies voor een streepjescode scannen en scan onderstaande QR-code.',
            instruction: 'Vul na het scannen de zes cijferige code in die in de app staat.',
          },
          success: {
            title: 'Authenticator app ingesteld',
            description:
              'De Authenticator app is nu gekoppeld aan je account. Vanaf nu dien je in te loggen met je e-mailadres, wachtwoord en de Authenticator app.',
          },
        },
      },
      information: {
        editDrawer: {
          title: 'Profiel bewerken',
        },
        feedback: {
          profileSaved: 'Profiel is opgeslagen',
          profileNotSaved: 'Profiel kon niet worden opgeslagen',
        },
      },
    },
    rbac: {
      title: 'Rollen en Rechten',
      create: {
        title: 'Nieuwe rol',
      },
      edit: {
        title: 'Rol wijzigen',
      },
      delete: {
        title: 'Rol verwijderen',
        text: 'Weet je zeker dat je deze rol wil verwijderen?',
      },
      feedback: {
        roleCreated: 'Rol toegevoegd',
        roleNotCreated: 'Rol toevoegen mislukt',
        roleSaved: 'Rol bijgewerkt',
        roleNotSaved: 'Rol kan niet worden bijgewerkt',
        roleDeleted: 'Rol verwijderd',
        roleNotDeleted: 'Rol kan niet worden verwijderd',
      },
    },
    confirmIdeal: {
      title: 'Bevesting automatische incasso',
      steps: {
        confirmed: {
          title: 'Bevestiging ontvangen',
          description: 'Bedankt, je hebt onderstaand rekeningnummer bevestigd:',
        },
        accountName: {
          title: 'Rekeninghouder opgeven',
          description:
            'Om automatische incasso te activeren hebben we nog de naam van de rekeninghouder nodig (zoals deze op je bankpas staat).',
        },
      },
      paymentFailed: {
        title: 'Betaling mislukt',
        description:
          'De betaling is mislukt, probeer het opnieuw met dezelfde of een andere bank of ga terug.',
      },
      feedback: {
        accountConfirmed: 'Betaalmethode opgeslagen',
        accountNotConfirmed: 'Betaalmethode kon niet worden opgeslagen',
      },
    },
    settings: {
      title: 'Instellingen',
      alert: {
        message:
          "Dit zijn globale instellingen die als standaard worden gebruikt. Als je specifiek voor een verkoopkanaal de instellingen wilt wijzigen, kun je dit bij 'Verkoopkanalen' doen.",
      },
      subNavigation: {
        general: 'Algemeen',
        credentials: 'Credentials',
        developerSettings: 'Ontwikkelaarsinstellingen',
      },
      credentials: {
        sections: {
          orders: {
            title: 'Orders',
            editDrawer: {
              shopCtrl: {
                title: 'ShopCtrl credentials wijzigen',
              },
            },
            feedback: {
              shopCtrlCredentialsSaved: 'ShopCtrl credentials zijn bijgewerkt',
              shopCtrlCredentialsNotSaved: 'ShopCtrl credentials konden niet worden bijgewerkt',
            },
          },
        },
      },
      general: {
        pricingSettings: {
          title: 'Prijsgroep',
          feedback: {
            pricingSettingsUpdated: 'Prijsgroep gewijzigd',
            pricingSettingsNotUpdated: 'Prijsgroep kon niet worden gewijzigd',
          },
          editDrawer: {
            title: 'Prijsgroep wijzigen',
          },
        },
        orderProcessingSettings: {
          title: 'Order proces standaarden',
          feedback: {
            orderProcessingSettingsUpdated: 'Order proces standaarden gewijzigd',
            orderProcessingSettingsNotUpdated:
              'Order proces standaarden konden niet worden gewijzigd',
          },
          editDrawer: {
            title: 'Order proces standaarden wijzigen',
            fieldOptions: {
              auto: 'Automatisch',
              none: 'Geen',
              manual: 'Handmatig',
            },
          },
        },
        channelInfoSettings: {
          title: 'Kanaal informatie',
          feedback: {
            channelInfoSettingsUpdated: 'Kanaal informatie gewijzigd',
            channelInfoSettingsNotUpdated: 'Kanaal informatie kon niet worden gewijzigd',
          },
          editDrawer: {
            title: 'Kanaal informatie wijzigen',
          },
        },
        posReceiptInfoSettings: {
          title: 'Kassabon informatie',
          feedback: {
            posReceiptInfoSettingsUpdated: 'Kassbon informatie gewijzigd',
            posReceiptInfoSettingsNotUpdated: 'Kassbon informatie kon niet worden gewijzigd',
          },
          editDrawer: {
            title: 'Kanaal informatie wijzigen',
          },
        },
        emailBCCSettings: {
          title: 'Berichtgeving kopie adressen',
          subtitle: 'Verstuur kopieën van berichtgeving naar onderstaande adressen',
          feedback: {
            emailBCCSettingsUpdated: 'Berichtgeving kopie adressen gewijzigd',
            emailBCCSettingsNotUpdated: 'Berichtgeving kopie adressen konden niet worden gewijzigd',
          },
          editDrawer: {
            title: 'Berichtgeving kopie adressen wijzigen',
          },
        },
        shippingMethodSettings: {
          title: 'Verzendmethodes',
          subtitle: 'Hernoem of zet methodes uit',
          count: '{count} methodes bewerkt',
          feedback: {
            shippingMethodSettingsUpdated: 'Verzendmethodes gewijzigd',
            shippingMethodSettingsNotUpdated: 'Verzendmethodes konden niet worden gewijzigd',
          },
          editDrawer: {
            title: 'Verzendmethodes wijzigen',
          },
        },
        servicePointSettings: {
          title: 'Afhaalpunten',
          feedback: {
            servicePointSettingsUpdated: 'Afhaalpunten gewijzigd',
            servicePointSettingsNotUpdated: 'Afhaalpunten konden niet worden gewijzigd',
          },
          editDrawer: {
            title: 'Afhaalpunt wijzigen',
          },
        },
        paymentMethodSettings: {
          title: 'Betaalmethodes',
          subtitle: 'Hernoem of zet methodes uit',
          count: '{count} methodes bewerkt',
          feedback: {
            paymentMethodsSettingsUpdated: 'Betaalmethodes gewijzigd',
            paymentMethodsSettingsNotUpdated: 'Betaalmethodes konden niet worden gewijzigd',
          },
          editDrawer: {
            title: 'Betaalmethodes wijzigen',
          },
        },
        routesSettings: {
          title: 'Routes prioritering',
          feedback: {
            routingSettingsUpdated: 'Routes prioritering gewijzigd',
            routingSettingsNotUpdated: 'Routes prioritering kon niet  worden gewijzigd',
          },
          editDrawer: {
            title: 'Routes prioritering wijzigen',
          },
        },
        vendorSettings: {
          title: 'Verkoper',
          feedback: {
            vendorSettingsUpdated: 'Verkoper gewijzigd',
            vendorSettingsNotUpdated: 'Verkoper kon niet worden gewijzigd',
          },
          editDrawer: {
            title: 'Verkoper wijzigen',
          },
        },
        notificationSettings: {
          title: 'Email berichtgeving afzender',
          feedback: {
            notificationSettingsUpdated: 'Email berichtgeving afzender gewijzigd',
            notificationSettingsNotUpdated:
              'Email berichtgeving afzender kon niet worden gewijzigd',
          },
          editDrawer: {
            title: 'Email berichtgeving afzender wijzigen',
          },
        },
        AllocationSettings: {
          title: 'Allocatie prioritering',
          feedback: {
            allocationSettingsUpdated: 'Allocatie prioritering gewijzigd',
            allocationSettingsNotUpdated: 'Allocatie prioritering kon niet worden gewijzigd',
          },
          editDrawer: {
            title: 'Allocatie prioritering wijzigen',
          },
        },
        transferSettings: {
          title: 'Overdracht instellingen',
          feedback: {
            transferSettingsUpdated: 'Overdracht instellingen gewijzigd',
            transferSettingsNotUpdated: 'Overdracht instellingen kon niet worden gewijzigd',
          },
          editDrawer: {
            title: 'Overdracht instellingen wijzigen',
          },
        },
        orderFiltersSettings: {
          title: 'Order filters',
          display: {
            brandFilters: 'Merk filters',
          },
          feedback: {
            orderFiltersSettingsUpdated: 'Merk filters opgeslagen',
            orderFiltersSettingsNotUpdated: 'Merk filters kon niet worden opgeslagen',
          },
          editDrawer: {
            title: 'Merk filters aanpassen',
          },
        },
        orderTagsSettings: {
          title: 'Order labels',
          display: {
            label: 'Labels',
          },
          feedback: {
            orderTagsSettingsUpdated: 'Order labels opgeslagen',
            orderTagsSettingsNotUpdated: 'Order labels konden niet worden opgeslagen',
          },
          editDrawer: {
            title: 'Order labels aanpassen',
            fields: {
              code: {
                helperText: "Gebruik alleen kleine letters, nummers of een '-'",
              },
            },
          },
        },
      },
    },
    viewOauthClient: {
      unknownClient: {
        title: 'Onbekende client',
        message: 'Deze client bestaat niet',
      },
    },
    viewPurgeRequest: {
      title: 'Opschoon verzoek',
      expiredTitle: 'Opschoon verzoek verlopen',
      usedTitle: 'Gebruikte opschoon token',
      description:
        '{requester} heeft een opschoon verzoek ingediend voor jouw contract. Hierbij word onderstaande data permanent verwijderd. Na het opschonen is deze data niet meer terug te halen.',
      expiredDescription:
        '{requester} heeft een opschoon verzoek ingediend voor jouw contract. Dit verzoek is echter verlopen maar bevatte onderstaande data om op te schonen.',
      usedDescription:
        'Deze opschoon token is al gebruikt. Dien een nieuw verzoek in om een nieuwe aan te verkrijgen.',
      expiryNotice: 'Dit opschoon verzoek verloopt {date}',
      dataToPurge: 'Data om op te schonen',
      confirmPurgeData: {
        title: 'Contract opschonen',
        description:
          'Weet je heel zeker dat je deze data voor je contract wilt opschonen? De data wordt permanent verwijderd en kan dus niet worden terug gehaald.',
      },
    },
  },
  viewSelection: {
    title: 'Opgeslagen views',
    actions: {
      setAsDefault: 'Instellen als standaard',
    },
    confirmDeleteView: {
      title: 'View verwijderen',
      description: 'Weet je zeker dat je deze view wilt verwijderen?',
      buttons: {
        cancel: 'Annuleren',
        delete: 'Verwijderen',
      },
    },
  },
  filterSelection: {
    title: 'Filters',
    resetButton: 'Reset filters',
    rowCount: '{count} van {total}',
    filterSelectionItem: {
      cancelButton: 'Annuleren',
      saveButton: 'Opslaan',
      createButton: 'Toevoegen',
      newFilterHeader: 'Filter toevoegen',
    },
  },
  dataGrid: {
    defaultView: {
      name: 'Standaard',
      description: 'Standaard weergave',
    },
    columns: {
      auditLogs: {
        actor: 'Gebruiker',
        action: 'Actie / Code',
        url: 'Url',
        category: 'Categorie',
        resource: 'Bron',
        stream: 'Stream',
        trace: 'Trace',
        processedAt: 'Verwerkt op',
        createdAt: 'Aangemaakt op',
      },
      users: {
        user: 'Gebruiker',
        roles: 'Rollen',
        is_verified: 'E-mailadres bevestigd',
        email: 'E-mailadres',
        first_name: 'Voornaam',
        last_name: 'Achternaam',
        search: 'Zoeken op',
        created_at: 'Aangemaakt op',
        updated_at: 'Bijgewerkt op',
      },
      channels: {
        name: 'Naam',
        description: 'Omschrijving',
        type: 'Type',
        client: 'Koppeling',
        createdAt: 'Aangemaakt op',
        updatedAt: 'Bijgewerkt op',
      },
      approvedAuthorizations: {
        user: 'Gebruiker',
        roles: 'Rollen',
        type: 'Type',
        actions: 'Acties',
      },
      pendingAuthorizations: {
        user: 'Gebruiker',
        email: 'E-mail',
        roles: 'Rollen',
        state: 'Status',
        invitedAt: 'Uitgenodigd op',
        requestedAt: 'Aangevraagd op',
        actions: 'Acties',
      },
      myPendingInvites: {
        company: 'Bedrijf',
        email: 'E-mail',
        roles: 'Rollen',
        state: 'Status',
        invitedAt: 'Uitgenodigd op',
        actions: 'Acties',
      },
      myPendingRequests: {
        state: 'Status',
        email: 'E-mail',
        roles: 'Rollen',
        requestedAt: 'Aangevraagd op',
        actions: 'Acties',
      },
      rbac: {
        name: 'Naam',
        scopes: 'Rechten',
      },
      integrations: {
        name: 'Naam',
        app: 'App',
        isInstalled: 'Geïnstalleerd',
        activeAt: 'Actief op',
        createdAt: 'Aangemaakt op',
        deletedAt: 'Verwijderd op',
      },
      invites: {
        invitee: 'Genodigde',
        status: 'Status',
        actions: 'Acties',
      },
      invoices: {
        invoice: 'Factuur',
        actions: 'Acties',
      },
      oauthClients: {
        name: 'Naam',
        grantTypes: 'Grant types',
        redirectUri: 'Redirect uri',
        createdAt: 'Aangemaakt op',
      },
    },
    sortSelection: {
      title: 'Sortering',
      resetButton: 'Reset sortering',
    },
    sortDirections: {
      asc: 'Oplopend',
      desc: 'Aflopend',
    },
    sortOptionSelectionItem: {
      cancelButton: 'Annuleren',
      saveButton: 'Opslaan',
      createButton: 'Toevoegen',
      newSortOptionHeader: 'Sortering toevoegen',
    },
    filters: {
      label: {
        between: '{name} tussen {first} en {second}',
      },
    },
    filterOperators: {
      is: 'Is gelijk aan',
      in: 'Bevat',
      missing: 'Bevat geen waarde',
      not_in: 'Bevat niet',
      gt: 'Is groter dan',
      gte: 'Is groter dan of gelijk aan',
      lt: 'Is kleiner dan',
      lte: 'Is kleiner dan of gelijk aan',
      between: 'Is tussen',
    },
    filterValues: {
      noValue: 'geen waarde',
    },
    filterConjunctions: {
      and: 'en',
    },
    columnSelection: {
      title: 'Kolommen',
      searchField: {
        placeholder: 'Zoeken ...',
      },
      addColumn: {
        label: 'Kolom toevoegen',
      },
      availableColumns: {
        label: 'Beschikbare kolommen',
      },
      selectedColumns: {
        label: 'Geselecteerde kolommen',
      },
      resetButton: 'Reset kolommen',
    },
    addColumn: {
      title: 'Kolom toevoegen',
      inputs: {
        name: {
          label: 'Naam',
        },
        formula: {
          label: 'Formule',
        },
      },
      buttons: {
        cancel: 'Annuleren',
        save: 'Opslaan',
      },
    },
    gridActions: {
      view: {
        title: 'Views',
        settings: 'Instellingen',
        views: 'Views',
        showMore: 'Toon meer',
        saveAs: 'Opslaan als',
        manageSettings: 'Beheren',
        defaultSettings: 'Terugzetten naar standaard',
      },
      columnSelection: {
        title: 'Kolommen',
      },
      sorting: {
        title: 'Sortering',
      },
      dataExport: {
        title: 'Exporteren',
        currentColumns: 'Huidige kolommen',
        allColumns: 'Alle kolommen',
        csv: 'CSV',
        excel: 'Excel',
        pdf: 'PDF',
      },
      dataImport: {
        title: 'Importeren',
      },
      copyGridUrl: {
        title: 'URL kopiëren',
        tooltip: 'Url gekopieerd',
      },
    },
    search: {
      placeholder: 'Zoek',
      exactMatch: 'Exacte match: {state}',
    },
    selection: {
      button: {
        all: 'Alles',
      },
      selected: '{count} van {total} geselecteerd',
    },
    pagination: {
      currentPageLabel: 'pagina {page}',
      previousPageLabel: 'Vorige pagina',
      nextPageLabel: 'Volgende pagina',
      displayedRows: '{from} - {to} van {count}',
      rowsPerPage: 'Rijen per pagina:',
      many: 'veel',
    },
    exportSelection: {
      title: 'Exporteren',
    },
    views: {
      label: {
        system: 'Systeem',
        private: 'Privé',
      },
    },
    viewSelectionMenu: {
      activeView: {
        label: 'Weergave',
      },
    },
    saveView: {
      title: 'Weergave opslaan als',
      showViewInformation: {
        button: {
          show: 'Toon informatie',
          hide: 'Verberg informatie',
        },
        columns: 'Kolommen',
        filters: 'Filters',
        sorting: 'Sortering',
        itemsPerPage: 'Rijen per pagina',
      },
      inputs: {
        name: {
          label: 'Naam',
          helperText: 'Gebruik een bestaande naam om de weergave te overschrijven',
        },
        saveViewForTenant: {
          label: 'Beschikbaar voor elke gebruiker',
        },
      },
      buttons: {
        cancel: 'Annuleren',
        save: 'Opslaan',
      },
    },
  },
  formFields: {
    searchUser: {
      placeholder: 'Zoek een gebruiker',
    },
  },
  applicationUpdateNotification: {
    updateAvailableMessage: 'Nieuwe versie van de app beschikbaar',
    updateButton: {
      label: 'Bijwerken',
    },
  },
  relativeDate: {
    properties: {
      quantity: 'Aantal',
      dayOfWeek: 'Dag van de week',
      dayOfMonth: 'Dag van de maand',
      type: 'Type',
      time: 'Tijd',
    },
    dateTypeOptions: {
      minutes: 'Minuten',
      hours: 'Uren',
      days: 'Dagen',
      weeks: 'Weken',
      months: 'Maanden',
    },
  },
  actions: {
    add: 'Toevoegen',
    back: 'Terug',
    continue: 'Verder',
    confirm: 'Bevestigen',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    filter: 'Filter',
    goToList: 'Bekijk overzicht',
    save: 'Opslaan',
    edit: 'Wijzigen',
    configure: 'Instellen',
    disable: 'Uitschakelen',
    activate: 'Activeren',
    retry: 'Opnieuw proberen',
    pay: 'Betalen',
    purge: 'Opschonen',
    requestPurge: 'Verzoek indienen',
    close: 'Sluiten',
    view: 'Bekijken',
  },
  filter: {
    showLogsWhere: 'Toon logs waar',
    selectAnOption: 'Selecteer een optie...',
    equals: 'Is gelijk aan',
    chipContent: {
      equals: '{filter} is {option}',
    },
  },
  pagination: {
    pageNumber: 'Pagina {i}',
  },
  formActions: {
    cancel: 'Annuleren',
    save: 'Opslaan',
    next: 'Volgende',
    verify: 'Verifiëren',
    finish: 'Afronden',
  },
  auditLogProperties: {
    method: 'Actie',
    resource: 'Bron',
    user: 'Gebruiker',
    timestamp: 'Datum',
    city: 'Plaats',
    client: 'Client',
    clientId: 'Client ID',
    country: 'Land',
    exp: 'Exp',
    ip: 'IP-adres',
    jti: 'Jti',
    userAgent: 'User agent',
  },
  userInviteStatuses: {
    expired: 'Verlopen',
    open: 'Open',
  },
  createChannelDrawer: {
    title: 'Verkoopkanaal aanmaken',
    feedback: {
      channelCreated: 'Verkoopkanaal aangemaakt',
      channelNotCreated: 'Verkoopkanaal kon niet worden aangemaakt',
    },
  },
  editChannelDrawer: {
    title: 'Verkoopkanaal bijwerken',
    feedback: {
      channelUpdated: 'Verkoopkanaal bijgewerkt',
      channelNotUpdated: 'Verkoopkanaal kon niet worden bijgewerkt',
    },
  },
  integrationPreview: {
    title: 'Integratie',
  },
  createIntegrationDrawer: {
    title: 'Integratie toevoegen',
  },
  editIntegrationDrawer: {
    title: 'Integratie wijzigen',
    feedback: {
      integrationUpdated: 'Integratie bijgewerkt',
      integrationNotUpdated: 'Integratie kon niet worden bijgewerkt',
    },
  },
  appsList: {
    app: {
      byAuthor: 'Door {author}',
      actions: {
        add: 'App toevoegen',
      },
    },
    emptyMessage: 'Geen apps beschikbaar',
    feedback: {
      integrationAlreadyAdded: 'Je kunt maar over 1 integratie beschikken voor deze app',
    },
  },
  confirmDeleteIntegration: {
    title: 'Integratie verwijderen',
    description: 'Weet je zeker dat je deze integratie wilt verwijderen?',
    feedback: {
      integrationDeleted: 'Integratie verwijderd',
      integrationNotDeleted: 'Integratie kon niet worden verwijderd',
    },
  },
  integrationParameters: {
    division_id: 'Administratie ID',
  },
  paymentCredentialSettings: {
    title: 'Betaal integraties',
  },
  shipmentCredentialSettings: {
    title: 'Verzend integraties',
  },
  credentialItem: {
    feedback: {
      credentialsUpdated: 'Credentials zijn bijgewerkt',
      credentialsNotUpdated: 'Credentials konden niet worden bijgewerkt',
    },
  },
  auditActions: {
    flowExecuted: 'Dataflow uitgevoerd',
    orderAccepted: 'Order geaccepteerd',
    customerNotified: 'Klant geinformeerd',
    orderFulfilled: 'Order fulfilment gestart',
    orderConfirmed: 'Order geaccepteerd',
    orderAllocated: 'Order voorraad toegewezen',
    calculationCreated: 'Offerte aangemaakt',
    orderCreated: 'Order aangemaakt',
    orderCanceled: 'Order geannuleerd',
    itemsAdded: 'Items toegevoegd',
    oauthClientCreated: 'Koppeling aangemaakt',
    userAuthorized: 'Gebruiker geautoriseerd',
    machineAuthorized: 'Systeem geautoriseerd',
    shopctrlAnnounced: 'Aangemeld bij ShopCtrl',
    shopctrlOrderAlreadyAvailable: 'Order is al aangemeld bij ShopCtrl',
  },
  auditActors: {
    system: 'Systeem',
  },
  auditCategories: {
    audit: 'Audit',
    request: 'Netwerkverzoek',
    error: 'Fout',
  },
  auditEntities: {
    order: 'Order',
    calculation: 'Offerte',
    invoice: 'Factuur',
    transaction: 'Transactie',
    user: 'Gebruiker',
    dataflow: 'Dataflow',
    contact: 'Contact',
    organisation: 'Organisatie',
    shipment: 'Verzending',
    list: 'Werklijst',
    parcel: 'Pakket',
  },
  settings: {
    pos: 'POS',
    invoicing: 'Facturatie',
    messaging: 'Berichtgeving',
    shipping: 'Verzending',
    payment: 'Betaling',
    orders: 'Orders',
    wms: 'WMS',
  },
  properties: {
    afostoCmsShippingMethod: 'Afosto 2.0 verzend methode',
    name: 'Naam',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    email: 'E-mailadres',
    billing_email: 'Factuur e-mailadres',
    bank: 'Bank',
    accountHolderName: 'Naam rekeninghouder',
    accountNumber: 'Rekeningnummer',
    phoneNumber: 'Telefoonnummer',
    phone_number: 'Telefoonnummer',
    formula: 'Formule',
    isActive: 'Actief',
    inactive: 'Inactief',
    oauthClientName: 'Naam',
    redirectUri: 'Redirect uri',
    redirect_uri: 'Redirect uri',
    grantTypes: 'Grant types',
    grant_types: 'Grant types',
    scopes: 'Rechten',
    oauthClientSecret: 'Client secret',
    oauthClientSecretTooltip: 'Client secret gekopieerd',
    oauthClientID: 'Client ID',
    oauthClientIDTooltip: 'Client ID gekopieerd',
    card_number: 'Kaartnummer',
    expiration_date: 'Verval datum',
    cvc: 'CVC',
    addressLine1: 'Straat en huisnummer',
    address_line_1: 'Straat en huisnummer',
    addressLine2: 'Extra adres gegevens',
    postalCode: 'Postcode',
    postal_code: 'Postcode',
    administrativeArea: 'Administratief gebied',
    administrative_area: 'Administratief gebied',
    city: 'Plaats',
    country: 'Land',
    countryCode: 'Land code',
    country_code: 'Land code',
    vatNumber: 'BTW nummer',
    billingEmail: 'Factuur e-mailadres',
    code: 'Code',
    sms: 'Telefoonnummer',
    signee: 'E-mailadres',
    roles: 'Rollen',
    configure: 'Instellen',
    notConfigured: 'Nog niet ingesteld',
    edit: 'Wijzigen',
    amount: 'Bedrag',
    pdf: 'PDF',
    otp: 'Code',
    apiKey: 'API key',
    apiSecret: 'API secret',
    apiToken: 'API token',
    serviceId: 'Service ID',
    tokenCode: 'Token code',
    yes: 'Ja',
    no: 'Nee',
    priceGroup: 'Prijsgroep',
    groupId: 'Prijsgroep',
    isVatShiftDisabled: 'Btw verleggen uitgeschakeld',
    inboundLocation: 'Binnenkomende locatie',
    inboundLocationId: 'Binnenkomende locatie',
    collectionLocation: 'Verzamel locatie',
    collectionLocationId: 'Verzamel locatie',
    internalShippingMethod: 'Interne verzendmethode',
    internalShipmentMethodId: 'Interne verzendmethode',
    backOrderInboundLocation: 'Backorders binnenkomende locatie',
    backOrderInboundLocationId: 'Backorders binnenkomende locatie',
    routes: 'Routes',
    locations: 'Locaties',
    location: 'Locatie',
    ordinal: 'Rangschikking',
    on: 'Aan',
    off: 'Uit',
    username: 'Gebruikersnaam',
    password: 'Wachtwoord',
    shippingMethod: 'Verzendmethode',
    paymentMethod: 'Betaalmethode',
    methods: 'Methodes',
    label: 'Label',
    isEnabled: 'Actief',
    color: 'Kleur',
    tags: 'Labels',
    capture: 'Facturering',
    allocation: 'Allocatie',
    confirm: 'Bevestigen',
    fulfilment: 'fulfilment',
    siteUrl: 'Website url',
    logo: 'Logo',
    addresses: 'Adressen',
    headerText: 'Header tekst',
    footerText: 'Footer tekst',
    priorityNumber: 'Volgorde nummer',
    description: 'Omschrijving',
    activeAt: 'Actief op',
    createdAt: 'Aangemaakt op',
    updatedAt: 'Bijgewerkt op',
    authorName: 'Naam auteur',
    multipleIntegrationsAllowed: 'Meerdere integraties toegestaan',
    app: 'App',
    isInstalled: 'Geïnstalleerd',
    configuration: 'Instellingen',
    credentials: 'Inloggegevens',
    host: 'Host',
    port: 'Poort',
    root: 'Hoofdmap',
    isPassive: 'Passieve FTP',
    isSecure: 'Beveiligde FTP (SSL)',
    unknownMethod: 'Onbekende methode',
    delisId: 'Delis ID',
    secret: 'Secret',
    oauthClientKey: 'Oauth client key',
    channel: 'Verkoopkanaal',
    webhookUrl: 'Webhook url',
    recaptchaSiteKey: 'Site key',
    recaptchaSecret: 'Secret',
    shopctrlUrl: 'ShopCtrl url',
    integration: 'Integratie',
    servicePoints: 'Afhaalpunten',
    openingTimes: 'Openingstijden',
    slackChannel: 'Slack channel',
    clientId: 'Client ID',
    defaultShippingMethod: 'Standaard verzendmethode',
    bolShippingMethod: 'Bol.com verzendmethode',
    shippingMethods: 'Verzendmethoden',
    restrictedTo: 'Beperkt tot',
    externalServiceId: 'External service ID',
    defaultShippingAddress: 'Standaard verzendadres ID',
    spid: 'Service punt',
  },
  status: {
    paid: 'Betaald',
    outstanding: 'Openstaand',
    concept: 'Concept',
  },
  fileUpload: {
    labelIdle:
      'Sleep & upload bestanden of <span class="filepond--label-action"> selecteer bestanden </span>',
    labelInvalidField: 'Veld bevat niet ondersteunde bestanden',
    labelFileWaitingForSize: 'Wachten op bestandsgrootte',
    labelFileSizeNotAvailable: 'Bestandsgrootte niet beschikbaar',
    labelFileLoading: 'Aan het laden',
    labelFileLoadError: 'Fout opgetreden tijdens het laden',
    labelFileProcessing: 'Bezig met uploaden',
    labelFileProcessingComplete: 'Upload voltooid',
    labelFileProcessingAborted: 'Upload geannuleerd',
    labelFileProcessingError: 'Fout opgetreden tijdens het uploaden',
    labelFileProcessingRevertError: 'Fout opgetreden tijdens het ongedaan maken',
    labelFileRemoveError: 'Fout opgetreden tijdens het verwijderen',
    labelTapToCancel: 'Tik om te annuleren',
    labelTapToRetry: 'Tik om opnieuw te proberen',
    labelTapToUndo: 'Tik om ongedaan te maken',
    labelButtonRemoveItem: 'Verwijderen',
    labelButtonAbortItemLoad: 'Afbreken',
    labelButtonRetryItemLoad: 'Opnieuw',
    labelButtonAbortItemProcessing: 'Annuleren',
    labelButtonUndoItemProcessing: 'Ongedaan maken',
    labelButtonRetryItemProcessing: 'Opnieuw',
    labelButtonProcessItem: 'Upload',
    labelMaxFileSize: 'Maximale bestandsgroote is {filesize}',
    labelMaxTotalFileSize: 'Maximale totale bestandsgroote is {filesize}',
    labelMaxFileSizeExceeded: 'Maximale bestandsgroote overschreden',
    labelMaxTotalFileSizeExceeded: 'Maximale totale bestandsgroote overschreden',
    labelFileTypeNotAllowed: 'Bestandstype niet toegestaan',
    fileValidateTypeLabelExpectedTypes: 'Verwacht bestandstype {allTypes}',
    duplicateFileDialog: {
      title: 'Bestand bestaat al',
      description: 'Er bestaat al een bestand met de naam "{filename}" in deze folder',
      buttons: {
        cancel: 'Annuleren',
        resolve: 'Automatisch hernoemen',
        upsert: 'Overschrijven',
      },
    },
  },
  errors: {
    validation: {
      empty: '{target} mag niet leeg zijn',
      matches: '{target} bevat tekens die niet geldig zijn',
      urlHasProtocol: "{target} dient te beginnen met 'https://' of 'http://'",
      validUrl: '{target} dient een geldige URL te zijn',
      validEmailFormat: 'Vul een geldig e-mail adres in',
      required: '{target} mag niet leeg zijn',
      validEmail: 'Vul een geldig e-mail adres in',
      url: '{target} dient een geldige URL te zijn',
      integer: '{target} moet een geheel getal zijn',
      minLength: '{target} moet minstens {min} karakters lang zijn',
      maxLength: '{target} mag maximaal {max} karakters lang zijn',
      minNumber: '{target} moet minimaal {min} zijn',
      maxNumber: '{target} moet kleiner zijn of gelijk aan {max}',
      minItems: '{target} moet minimaal {min} items bevatten',
      maxItems: '{target} mag maximaal {max} items bevatten',
      atLeastOneNormalCharacter: '{target} mag niet alleen speciale tekens bevatten',
    },
    response: {
      unableToVerify2fa: 'Kan niet verifiëren met ingevulde code',
    },
  },
  components: {
    autocomplete: {
      clearText: 'Legen',
      loadingText: 'Laden...',
      noOptionsText: 'Geen opties',
      openText: 'Open',
    },
  },
  arrayField: {
    actions: {
      add: 'Toevoegen',
      remove: 'Verwijderen',
    },
  },
  paymentMethods: {
    providers: {
      tenant: 'Eigen beheer',
    },
    tenant: {
      cod: 'Contant bij aflevering',
      on_account: 'Op rekening',
      bank_transfer: 'Bank overschrijving',
      cash: 'Contant',
      manual_gift_card: 'Cadeaubon manueel',
      manual_card_transaction: 'Kaarttransactie manueel',
    },
  },
  scopeParts: {
    app: 'Applicaties',
    integrations: 'Integraties',
    mapping: 'Mapping',
    prices: 'Prijzen',
    files: 'Bestanden',
    filesystems: 'Externe opslag',
    index: 'Index',
    proxies: 'Proxies',
    video: 'Video',
    '2fa': 'Twee staps verificatie',
    customer: 'Klant',
    services: 'Services',
    subscriptions: 'Abonnementen',
    tenants: 'Contract',
    usage: 'Gebruik',
    users: 'Gebruikers',
    dpd: 'DPD',
    handling: 'Werklijsten',
    locations: 'Locaties',
    points: 'Afhaalpunten',
    shipments: 'Verzendingen',
    conversations: 'Gesprekken',
    domains: 'Domeinen',
    emails: 'E-mails',
    email: 'E-mail',
    inboxes: 'Inboxen',
    relays: 'Overdrachten',
    webhooks: 'Webhooks',
    credit: 'Credit',
    orders: 'Orders',
    payments: 'Betalingen',
    providers: 'Betaling verwerkers',
    skus: "SKU's",
    transactions: 'Transacties',
    contacts: 'Contacten',
    geocoding: 'Geolocatie',
    identity: 'Identiteit',
    network: 'Netwerk',
    printers: 'Printers',
    queue: 'Wachtrij',
    claim: 'Vorderingen',
    hops: 'Etappes',
    item: 'Item',
    location: 'Locaties',
    route: 'Route',
    schedule: 'Schema',
    sub: 'Sub overdrachten',
    transfers: 'Overdrachten',
    spl: 'Spooler',
    iam: 'Gebruikers',
    openid: 'OpenID',
    profile: 'Profielen',
    cnt: 'Content',
    mes: 'Berichten',
    odr: 'Orders',
    wms: 'Warehouse Management System',
    cat: 'Catalogus',
    lcs: 'Fulfilment',
    rel: 'Contacten',
    qcq: 'Quicq',
    read: 'Lezen',
    write: 'Schrijven',
    register: 'Registreren',
    create: 'Aanmaken',
    update: 'Bijwerken',
    invoices: 'Facturen',
    oauth: 'Authenticatie',
    audits: 'Audits',
    roles: 'Rollen',
    sources: 'Betaal bronnen',
    hubs: 'Hubs',
    logs: 'Logs',
  },
  scopeDescriptions: {
    email: 'Geeft toegang e-mail en verificatie statussen',
    'iam:2fa:read': 'Geeft lees rechten voor twee staps verificatie voor de huidige gebruiker',
    'iam:2fa:write': 'Geeft schrijf rechten voor twee staps verificatie voor de huidige gebruiker',
    'iam:audits:read': 'Geeft lees rechten tot audits',
    'iam:customer:read': 'Geeft lees rechten voor de klant data',
    'iam:customer:write': 'Geeft schrijf rechten voor de klant data',
    'iam:oauth:read': 'Geeft lees rechten voor de oAuth koppelingen',
    'iam:oauth:write': 'Geeft schrijf rechten voor de oAuth koppelingen',
    'iam:roles:read': 'Geeft lees rechten voor de rollen',
    'iam:roles:write': 'Geeft schrijf rechten voor de rollen',
    'iam:services:read': 'Geeft lees rechten voor de services',
    'iam:services:write': 'Geeft schrijf rechten voor de services',
    'iam:sources:read': 'Geeft lees rechten voor de betaal bronnen',
    'iam:sources:write': 'Geeft schrijf rechten voor de betaal bronnen',
    'iam:subscriptions:read': 'Geeft lees rechten voor de abonnementen',
    'iam:subscriptions:write': 'Geeft schrijf rechten voor de abonnementen',
    'iam:tenants:read': 'Geeft lees rechten voor het contract',
    'iam:usage:read': 'Geeft lees rechten voor de verbruiksdata',
    'iam:users:read': 'Geeft lees rechten voor de gebruikers',
    'iam:users:write': 'Geeft schrijf rechten voor de gebruikers',
    openid: 'Geeft rechten voor de sub / gebruikers id claim',
    profile: 'Geeft rechten voor de profielen',
    'spl:hubs:read': 'Geeft lees rechten voor de hubs',
    'spl:hubs:write': 'Geeft schrijf rechten voor de hubs',
    'spl:logs:read': 'Geeft lees rechten voor de logs',
    'spl:logs:write': 'Geeft schrijf rechten voor de logs',
    'spl:network:read': 'Geeft lees rechten voor het netwerk van een hub',
    'spl:network:write': 'Geeft schrijf rechten voor het netwerk van een hub',
    'spl:printers:read': 'Geeft lees rechten voor de printers',
    'spl:printers:write': 'Geeft schrijf rechten voor de printers',
    'spl:queue:create': 'Geeft aanmaak rechten voor de wachtrij',
    'spl:queue:read': 'Geeft lees rechten voor de wachtrij',
    'spl:queue:update': 'Geeft bijwerk rechten voor de wachtrij',
    'cnt:files:read': 'Geeft lees rechten voor de bestanden',
    'cnt:files:write': 'Geeft schrijf rechten voor de bestanden',
    'cnt:filesystems:read': 'Geeft lees rechten voor de externe opslagen',
    'cnt:filesystems:write': 'Geeft schrijf rechten voor de externe opslagen',
    'cnt:index:read': 'Geeft lees rechten voor de zoek index',
    'cnt:index:write': 'Geeft schrijf rechten voor de zoek index',
    'cnt:proxies:read': 'Geeft lees rechten voor de proxies',
    'cnt:proxies:write': 'Geeft schrijf rechten voor de proxies',
    'cnt:video:read': 'Geeft lees rechten voor de videos',
    'mes:conversations:read': 'Geeft lees rechten voor de gesprekken',
    'mes:conversations:register': 'Geeft registreer rechten voor de gesprekken',
    'mes:conversations:write': 'Geeft schrijf rechten voor de gesprekken',
    'mes:domains:read': 'Geeft lees rechten voor de domeinen',
    'mes:domains:write': 'Geeft schrijf rechten voor de domeinen',
    'mes:emails:read': 'Geeft lees rechten voor de e-mails',
    'mes:emails:write': 'Geeft schrijf rechten voor de e-mails',
    'mes:inboxes:read': 'Geeft lees rechten voor de inboxen',
    'mes:inboxes:write': 'Geeft schrijf rechten voor de inboxen',
    'mes:relays:read': 'Geeft lees rechten voor de overdrachten',
    'mes:relays:write': 'Geeft schrijf rechten voor de overdrachten',
    'mes:subscriptions:read': 'Geeft lees rechten voor de abonnementen',
    'mes:subscriptions:write': 'Geeft schrijf rechten voor de abonnementen',
    'mes:webhooks:read': 'Geeft lees rechten voor de webhooks',
    'odr:credit:read': 'Geeft lees rechten voor de credits',
    'odr:credit:write': 'Geeft schrijf rechten voor de credits',
    'odr:invoices:create': 'Geeft aanmaak rechten voor de facturen',
    'odr:invoices:read': 'Geeft lees rechten voor de facturen',
    'odr:invoices:update': 'Geeft bijwerk rechten voor de facturen',
    'odr:orders:read': 'Geeft lees rechten voor de orders',
    'odr:orders:write': 'Geeft schrijf rechten voor de orders',
    'odr:payments:update': 'Geeft bijwerk rechten voor de betalingen',
    'odr:providers:read': 'Geeft lees rechten voor de betaling verwerkers',
    'odr:skus:write': 'Geeft lees rechten voor de skus',
    'odr:stacks:read': 'Geeft lees rechten voor de order stacks',
    'odr:stacks:write': 'Geeft lees rechten voor de order stacks',
    'odr:transactions:create': 'Geeft aanmaak rechten voor de transacties',
    'wms:claim:read': 'Geeft lees rechten voor de vorderingen',
    'wms:claim:write': 'Geeft schrijf rechten voor de vorderingen',
    'wms:hops:read': 'Geeft lees rechten voor de etappes',
    'wms:hops:write': 'Geeft schrijf rechten voor de etappes',
    'wms:item:read': 'Geeft lees rechten voor de items',
    'wms:item:write': 'Geeft schrijf rechten voor de items',
    'wms:location:read': 'Geeft lees rechten voor de locaties',
    'wms:location:write': 'Geeft schrijf rechten voor de locaties',
    'wms:route:read': 'Geeft lees rechten voor de routes',
    'wms:route:write': 'Geeft schrijf rechten voor de routes',
    'wms:schedule:read': "Geeft lees rechten voor de schema's",
    'wms:schedule:write': "Geeft schrijf rechten voor de schema's",
    'wms:sub:read': 'Geeft lees rechten voor de sub overdrachten',
    'wms:sub:write': 'Geeft schrijf rechten voor de sub overdrachten',
    'wms:transfer:read': 'Geeft lees rechten voor de overdrachten',
    'wms:transfer:write': 'Geeft schrijf rechten voor de overdrachten',
    'wms:warehouse:read': 'Geeft lees rechten voor de warehuizen',
    'wms:warehouse:write': 'Geeft schrijf rechten voor de warehuizen',
    'cat:mapping:read': 'Geeft lees rechten voor de mapping',
    'cat:mapping:write': 'Geeft schrijf rechten voor de mapping',
    'cat:prices:read': 'Geeft lees rechten voor de prijzen',
    'cat:prices:write': 'Geeft schrijf rechten voor de prijzen',
    'lcs:locations:read': 'Geeft lees rechten voor de locaties',
    'lcs:locations:write': 'Geeft schrijf rechten voor de locaties',
    'rel:contacts:read': 'Geeft lees rechten voor de contacten',
    'rel:contacts:write': 'Geeft schrijf rechten voor de contacten',
    'rel:geocode:read': 'Geeft lees rechten voor de geolocatie',
    'rel:identity:read': 'Geeft lees rechten voor de identiteiten',
    'rel:identity:write': 'Geeft schrijf rechten voor de identiteiten',
    'lcs:dpd:read': 'Geeft lees rechten voor de DPD endpoints',
    'lcs:handling:read': 'Geeft lees rechten voor de werklijsten',
    'lcs:handling:write': 'Geeft schrijf rechten voor de werklijsten',
    'lcs:points:read': 'Geeft lees rechten voor de afhaalpunten',
    'lcs:shipments:read': 'Geeft lees rechten voor de verzendingen',
    'lcs:shipments:write': 'Geeft schrijf rechten voor de verzendingen',
    'qcq:proxies:read': 'Geeft lees rechten voor de proxies',
    'qcq:proxies:write': 'Geeft schrijf rechten voor de proxies',
  },
  sessionErrorDialog: {
    title: 'Ongeldige sessie',
    description:
      'Je sessie is verlopen of er heeft een fout plaats gevonden. Log opnieuw in om door te gaan met je sessie.',
    supportDescription:
      'Indien je deze melding direct weer te zien krijgt nadat je opnieuw bent ingelogd. Neem dan contact op met Afosto support.',
    actions: {
      loginAgain: 'Opnieuw inloggen',
    },
  },
};

export default translations;
